import { Directive, ElementRef, HostListener } from '@angular/core';

/** Pestañas accesibles: flechas, Inicio y Fin mueven el foco entre los `[role=tab]` del contenedor (patrón WAI-ARIA). */
@Directive({ selector: '[appTabsNav]', standalone: true })
export class TabsNavDirective {
  constructor(private readonly host: ElementRef<HTMLElement>) {}

  @HostListener('keydown', ['$event'])
  alPulsar(evento: KeyboardEvent): void {
    const tabs = Array.from(this.host.nativeElement.querySelectorAll<HTMLElement>('[role="tab"]'));
    const actual = tabs.indexOf(document.activeElement as HTMLElement);
    if (actual < 0 || !tabs.length) return;
    let destino = -1;
    if (evento.key === 'ArrowRight') destino = (actual + 1) % tabs.length;
    else if (evento.key === 'ArrowLeft') destino = (actual - 1 + tabs.length) % tabs.length;
    else if (evento.key === 'Home') destino = 0;
    else if (evento.key === 'End') destino = tabs.length - 1;
    if (destino < 0) return;
    evento.preventDefault();
    tabs[destino].focus();
    tabs[destino].click();
  }
}
